import {
  clearOnViewBeacon,
  clearOnLoadBeacon,
  refreshAdvertisementBeacons,
} from "../../store/actionCreators";
import {
  clearOnLoadBeaconReducer,
  clearOnViewBeaconReducer,
  refreshAdvertisementBeaconsReducer,
} from "../reducers";

export const registerDiagnosticsSlice = (builder, { syncProductsEntity }) => {
  builder
    .addCase(clearOnViewBeacon, clearOnViewBeaconReducer)
    .addCase(clearOnLoadBeacon, clearOnLoadBeaconReducer)
    .addCase(refreshAdvertisementBeacons, (state, { payload }) =>
      refreshAdvertisementBeaconsReducer(state, payload, {
        syncProductsEntity,
      }),
    );
};
